import { z } from "zod";
import { ZCalculateEarthingInput, ZCalculateEarthingOutput, } from "../earthing/calculateEarthing";
import { ZDateish, ZObjectIdString } from "./foundationSchema";
export const ZEarthingRunStatus = z.enum(["success", "error"]);
export const ZEarthingClient = z.object({
    clientName: z.string().optional(),
    clientVersion: z.string().optional(),
    runtimeName: z.string().optional(),
    runtimeVersion: z.string().optional(),
    machineNameHash: z.string().optional(),
    userNameHash: z.string().optional(),
});
export const ZEarthingRunError = z.object({
    name: z.string().optional(),
    message: z.string(),
    code: z.string().optional(),
    stack: z.string().optional(),
});
export const ZEarthingRunLog = z.object({
    _id: ZObjectIdString.optional(),
    route: z.literal("/earthing/calculate"),
    source: z.literal("api"),
    createdAt: ZDateish,
    startedAt: ZDateish,
    finishedAt: ZDateish.optional(),
    durationMs: z.number().int().nonnegative().optional(),
    status: ZEarthingRunStatus,
    request: z.object({
        requestId: z.string().optional(),
        ipHash: z.string().optional(),
        userAgent: z.string().optional(),
        client: ZEarthingClient.optional(),
        rawBody: z.unknown().optional(),
        input: ZCalculateEarthingInput.optional(),
    }),
    response: z.object({
        output: ZCalculateEarthingOutput.optional(),
        error: ZEarthingRunError.optional(),
    }),
    meta: z
        .object({
        inputBytes: z.number().int().nonnegative().optional(),
        outputBytes: z.number().int().nonnegative().optional(),
        apparatusFoundationCount: z.number().int().nonnegative().optional(),
        nodeCount: z.number().int().nonnegative().optional(),
        edgeCount: z.number().int().nonnegative().optional(),
    })
        .optional(),
});
export const ZEarthingRunListInput = z.object({
    limit: z.number().int().min(1).max(100).default(100),
});
export const ZEarthingRunListResponse = z.object({
    items: z.array(ZEarthingRunLog),
    limit: z.number().int().min(1).max(100),
    hasMore: z.boolean(),
});
